import React, { useCallback, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { pressPages } from '../data/images';
import { BeyondTheLobbyMark } from './BeyondTheLobbyMark';
import { PressReader } from './PressReader';
export function Press() {
  const {
    t
  } = useLanguage();
  const p = t.press;
  const [page, setPage] = useState<number | null>(null);
  const close = useCallback(() => setPage(null), []);
  return <section id="press" aria-labelledby="press-title" className="scroll-mt-20 bg-white py-24 md:py-32" data-id="element-267" data-mp="1gt5leuooandr">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-268" data-mp="1251baf3ork6l">
        <h2 id="press-title" className="flex flex-col items-center gap-3 text-center" data-id="element-269" data-mp="126cas2q3m5rw">
          <span className="text-[14px] font-semibold text-violet" data-id="element-270" data-mp="174485c9iik3h">{p.featuredIn}</span>
          <BeyondTheLobbyMark className="text-[26px] md:text-[30px]" data-id="element-271" data-mp="t54fltivpl21" />
        </h2>

        <article className="mt-14 grid items-center gap-10 lg:mt-16 lg:grid-cols-12 lg:gap-16" data-id="element-272" data-mp="x4d8yxa0bgx2">
          <button type="button" onClick={() => setPage(0)} aria-label={`${p.cta}: ${p.headline}`} className="group overflow-hidden rounded-[20px] border border-mist bg-white lg:col-span-5" data-id="element-273" data-mp="2zcgtal58minz">
            <img src={pressPages[0].src} alt={p.pageAlts[0]} loading="lazy" className="aspect-[5/4] w-full object-cover object-top transition-transform duration-300 ease-out group-hover:scale-[1.02]" data-id="element-274" data-mp="3993fped7phs4" />
          </button>

          <div className="lg:col-span-7" data-id="element-275" data-mp="2blkw18i0iv9c">
            <p className="font-serif text-[15px] italic text-muted" data-id="element-276" data-mp="2qd3m5z4l666f">{p.byline}</p>
            <h3 className="mt-3 font-serif text-[30px] font-medium leading-[1.2] text-ink md:text-[36px]" data-id="element-277" data-mp="2llvbz0vfmgs7">
              {p.headline}
            </h3>
            <p className="mt-4 text-[16px] text-muted" data-id="element-278" data-mp="1xuzkk4uw1nlh">{p.sub}</p>
            <blockquote className="mt-8 max-w-xl border-l-2 border-violet pl-5 font-serif text-[18px] italic leading-[1.6] text-charcoal" data-id="element-279" data-mp="1sxpq2asn6lqs">
              “{p.excerpt}”
            </blockquote>
            <button type="button" onClick={() => setPage(0)} className="group mt-8 inline-flex min-h-[44px] items-center gap-2 text-[15px] font-semibold text-violet transition-colors duration-200 hover:text-violet-deep" data-id="element-280" data-mp="2mmopzrp0kysp">
              {p.cta}
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-281" data-mp="1zmr0gamd0si6" />
            </button>
          </div>
        </article>

        <ul className="mt-16 grid gap-5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-282" data-mp="28mdx6j459a4w">
          {p.cards.map(card => <li key={card.title} data-id="element-283" data-mp="2dnjuyvcnvnla">
              <button type="button" onClick={() => setPage(card.page)} className="group flex h-full w-full flex-col overflow-hidden rounded-[20px] bg-stone text-left" data-id="element-284" data-mp="3k2b0xdgn5ym6">
                <div className="h-[220px] overflow-hidden bg-mist" data-id="element-285" data-mp="1debul16ehhox">
                  <img src={pressPages[card.page].src} alt={p.pageAlts[card.page]} loading="lazy" style={{
                objectPosition: pressPages[card.page].focus
              }} className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.03]" data-id="element-286" data-mp="18ez8wjr9mgnx" />
                </div>
                <div className="flex flex-1 flex-col p-6" data-id="element-287" data-mp="por7q774m0ad">
                  <h3 className="font-display text-[16px] font-semibold text-ink" data-id="element-288" data-mp="pn6auaxca59c">{card.title}</h3>
                  <p className="mt-2 text-[15px] leading-[1.7] text-muted" data-id="element-289" data-mp="kpn03kzuoam5">{card.body}</p>
                  <span className="mt-auto inline-flex items-center gap-2 pt-5 text-[14px] font-semibold text-violet" data-id="element-290" data-mp="frux9vxo3436">
                    {p.readMore}
                    <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-291" data-mp="2a4kt4j7lind7" />
                  </span>
                </div>
              </button>
            </li>)}
        </ul>
      </div>

      <PressReader page={page} onChange={setPage} onClose={close} data-id="element-292" data-mp="285t7mbcnx1d4" />
    </section>;
}